import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import ISEO from "../models/seo/ISEO";

const getPath = (p?: string) => p && p.startsWith("/") ? p.substring(1) : p || "";

const getBaseUrl = () => {
    const protocol = window.location.protocol;
    const host = window.location.host;
    return `${protocol}//${host}`;
}

const getPageUrl = (path?: string) => {
    const baseUrl = getBaseUrl();
    return `${baseUrl}/${getPath(path)}`;
}

const getImageUrl = (path?: string) => {
    const baseUrl = getBaseUrl();
    const isAbsolutePath = path?.startsWith("http://") || path?.startsWith("https://");
    
    return isAbsolutePath
        ? path :
        `${baseUrl}${path}`;
};

export default function SEO(props: ISEO) {
    const { t } = useTranslation("general");

    const baseUrl = getBaseUrl();

    const title = props.title?.pageTitle || t("website.title");
    const description = props.metaDescription || t("website.metaDescription");
    const keywords = props.keywords ? props.keywords.join(", ") : null;
    const img = getImageUrl(props.openGraph?.image || `${baseUrl}/img/banners/water.jpg`);

    return (
        <Helmet>
            
            <title>{title}</title>

            <link rel="canonical" href={getPageUrl(props.canonicalPath)} />

            { keywords && <meta name="keywords" content={keywords} /> }

            <meta name="description" content={description} />

            <meta property="og:title" content={props.openGraph?.title || title} />
            <meta property="og:description" content={props.openGraph?.description || description} />
            <meta property="og:image" content={img} />
            <meta property="og:url" content={getPageUrl(props.openGraph?.url)} />

            { props.openGraph?.type && <meta property="og:type" content={props.openGraph.type} /> }
            { props.openGraph?.locale && <meta property="og:locale" content={props.openGraph.locale} /> }

            {
                props.jsonLD &&
                props.jsonLD.map((json, index) => <script key={index} type="application/ld+json">{JSON.stringify(json)}</script>)
            }

        </Helmet>
    );
};